import React, { PropsWithChildren } from 'react';
import { Checkbox, LABEL_PLACEMENT, STYLE_TYPE } from 'baseui/checkbox';

import { TechemTheme } from '@techem/techem-theme';

interface Props {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => unknown;
  labelPlacement?: any;
  additionalTestId?: string;
}

const Toggle: React.FC<PropsWithChildren<Props>> = ({
  checked,
  onChange,
  labelPlacement,
  additionalTestId,
  children
}) => {
  return (
    <Checkbox
      labelPlacement={labelPlacement ? labelPlacement : LABEL_PLACEMENT.left}
      checked={checked}
      checkmarkType={STYLE_TYPE.toggle_round}
      onChange={onChange}
      overrides={{
        Toggle: {
          props: {
            'data-gi': `toggle${additionalTestId !== undefined ? ' ' + additionalTestId : ''}`
          },
          style: ({ $checked }) => ({
            width: '24px',
            height: '24px',
            backgroundColor: TechemTheme.colors.toggleFill,
            transform: $checked ? 'translateX(28px)' : 'translateX(0px)'
          })
        },
        ToggleTrack: {
          style: ({ $checked }) => ({
            boxSizing: 'border-box',
            width: '60px',
            height: '30px',
            padding: '4px',
            backgroundColor: $checked
              ? TechemTheme.colors.primary
              : TechemTheme.colors.toggleTrackFill,
            borderTopLeftRadius: '18px',
            borderTopRightRadius: '18px',
            borderBottomLeftRadius: '18px',
            borderBottomRightRadius: '18px'
          })
        },
        Label: {
          style: ({ $theme }) => ({
            alignSelf: 'center'
          })
        }
      }}
    >
      {children}
    </Checkbox>
  );
};

export default Toggle;
